import { JSEncrypt } from "jsencrypt";

const publicKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAuZjIS3AvyQCXaPE86MXq
AY0yJc55xttnRUmCSUSudS9f/3je+6sNghtxMa2Gh5+GcVp0wkAzieOzoA4dPUWG
EuNOuTqgll4hsd38W6xasbydrwb2JH7sJ3qDm5VBlrtKdEoqpykK8gq6PcoCdugI
nc5wvVslPRD0ncdJ0W1XZ24oH7/1VUVulBeiMad6h3YohpFKwMVf4oBtWsfSvEl1
M5dtcaJWGy70wDiNdbBsqKII0AteW3wTewkBWhaMjljHWsggLVCZHZn1zkWpVK9p
EkK0zNtuXURLEE0SWJ75GCQUEngE3hoZzG8CVmFp3jUuBhufEsgDHyv2sFxwcpbJ
HwIDAQAB
-----END PUBLIC KEY-----`;

const privateKey = `-----BEGIN PRIVATE KEY-----
MIIEvgIBADANBgkqhkiG9w0BAQEFAASCBKgwggSkAgEAAoIBAQC5mMhLcC/JAJdo
8TzoxeoBjTIlznnG22dFSYJJRK51L1//eN77qw2CG3ExrYaHn4ZxWnTCQDOJ47Og
Dh09RYYS4065OqCWXiGx3fxbrFqxvJ2vBvYkfuwneoOblUGWu0p0SiqnKQryCro9
ygJ26AidznC9WyU9EPSdx0nRbVdnbigfv/VVRW6UF6Ixp3qHdiiGkUrAxV/igG1a
x9K8SXUzl21xolYbLvTAOI11sGyoogjQC15bfBN7CQFaFoyOWMdayCAtUJkdmfXO
RalUr2kSQrTM225dREsQTRJYnvkYJBQSeATeGhnMbwJWYWneNS4GG58SyAMfK/aw
XHBylskfAgMBAAECggEBAKGTiDRcy80iza4X7t37h1ioctMFKXFdC0//ygQ9XeA5
SUrhEMdqyEzP1UDZf/hMgj/m7yU5vWS7LmMWRpBUGYASEjQh/TJLauwthQjOSPrZ
aTG6TsnBEZjhCPiG/V3bWdtZwj5a9eN4QWGPn4ujP/Uah33ifs3mF//QQsync2Nf
wAPkhkLaOIUzPXIHF/N8hOH8fJzyk1slSHZ8L1I6FtS6um2yxUwpc9WnAlrJkb5l
Ez9tCv8ktQlgWiVu4tGXNpPbKrXigDkGGvI3rpHNAju3g1m53QiL5ke7ZgdXhW9U
raUz9x1MIcI/go+ZLiHt3D7gHL9Joji4hnpP+twHXPkCgYEA6OAwsJllA/GofY1H
3WXFaQwH5Tdl0nxEUO33QfVrBIs9X5++XdkOKaDMSjmnKH1FnCJE+jtg4cgXOLS4
JtabSBmZErW5b6PAZsmrR5nWZ7xIYH4DNoRG7MhQAGhPhyvA9RYjK6RMtk/KbmiN
3Uo85Z9eJsix60qNjc9OiXRXTvMCgYEAzAa9WADg4/Z9ATeBZU/eEq1MwOWa51cq
OTkXYO5iGCnQcdAgUrN2uyT5UTZNYk21hJrtvmoYtSRvMLPdoruhViinssKAtq0j
WtV6lF8PozX/Ell5HWwkcOPYztszlRZ/CL17D+EodFerbPt0SNWWFzsIGQD6w/3C
otG1AdH+ICUCgYEAnxZAzPQNuTMGmrbAaHQU911bq3A75B42gV7/shSZRmJkzAWS
BAS7Ex8hUHewRQ3HVxFmM9gKqFOL4ZY703R6YjfyhYCVrLmeP9n3Y5Opj/ZlL14G
jeCxnyJ83Lpl0f7G8+dqoW69ZTJ/JQvSFmGX1noX1MD4IrgsmbsMeQR8fJcCgYAt
4a4e5kOswDeoWGUe9XEJXjOOhZPqRm3WZIJfZ/xjVrPrhFRghL9EorH2k3Gfk74o
Tfb9BTr9MW5X03saJ3vGtmnQB3GOoyz6NlvUlfQcTf5IkBpuhW1Efdi53A2jj2WN
/553GblRQI3qejnST0Xrf3j4toGuJZjpqKM9/41YiQKBgCVOECbDKvMQEk3cwaeC
A1TonIQra1GvWoKFmEQaFiAwOFANNXnW0DtKwlfRwAWcUtp0CaniJ2NW3i37WkoE
ImfoGlm1FpIKXTBMS+5RQJGV/QKYA7uS+jOAyrhiVZ/6+UW36IMqQkmJ66+xIEWb
3l9xYL9Wag9QHmeSQ+vzF111
-----END PRIVATE KEY-----`;

//加密方法

export default {
    RSAEncrypt(string) {
        //实例化jsEncrypt对象

        const jse = new JSEncrypt(); //设置公钥

        jse.setPublicKey(publicKey);

        // console.log("打印RSA。js：", jse.encrypt(string));

        return jse.encrypt(string);
    },

    //解密方法

    RSADecrypt(string) {
        const jse = new JSEncrypt(); //私钥

        jse.setPrivateKey(privateKey);

        return jse.decrypt(string);
    },
};
